import React from 'react';
import { Logo } from './Logo';
import { OfferBlock } from './OfferBlock';
import { IMAGES } from '../data/content';
export function Hero() {
  return <header className="bg-canvas px-5 pb-16 pt-8 sm:pt-12" data-id="element-181" data-mp="ehtkhzt5b7pe">
      <div className="mx-auto max-w-4xl" data-id="element-182" data-mp="9lv00naxu9u9">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center" data-id="element-183" data-mp="9igx9dyd3yma">
          <Logo data-id="element-184" data-mp="4jm4pkalevoz" />
          <span className="rounded-full border border-radar/30 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wider text-radar-deep" data-id="element-185" data-mp="129h37ug97cgl">
            Clinical Reference System
          </span>
        </div>

        <h1 className="mt-8 text-center font-display text-[2.6rem] font-bold uppercase leading-[1.05] text-navy-900 sm:text-6xl" data-id="element-186" data-mp="sb1ajn1kvv4z">
          Recognize 20+ Surgical Warning Signs in{' '}
          <span className="relative inline-block text-radar-deep" data-id="element-187" data-mp="3d1ildbzsjgoh">
            Under 10 Minutes
            <span className="absolute -bottom-1 left-0 h-1.5 w-full rounded-full bg-radar" aria-hidden="true" data-id="element-188" data-mp="3cz5wsfzj282g" />
          </span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-center font-display text-xl font-medium uppercase leading-snug text-alert-deep sm:text-2xl" data-id="element-189" data-mp="3j893b0s41pjq">
          — Before a small problem becomes a major implant complication
        </p>

        <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-190" data-mp="399thndbur8hm">
          A practical, step-by-step clinical reference system designed to help you recognize warning signals during
          implant treatment, reassess risk before it escalates, and make more structured decisions when something
          doesn't look right. Includes <strong className="text-ink" data-id="element-191" data-mp="2qkdcgcp82ruv">6 premium volumes</strong>,{' '}
          <strong className="text-ink" data-id="element-192" data-mp="2qi0mbc9b9b6q">5 professional bonus tools</strong>,{' '}
          <strong className="text-ink" data-id="element-193" data-mp="2vj7sj6vt22ba">30+ warning-sign protocols</strong>, clinical checklists, decision maps, and
          risk-assessment tools.
        </p>

        <figure className="-mx-5 mt-8 sm:mx-auto sm:max-w-2xl" data-id="element-194" data-mp="2ll0fv08ju6f3">
          <img src={IMAGES.product} alt="Implant Risk Radar™ — 6 volumes, digital tools on laptop, tablet and phone" className="w-full" data-id="element-195" data-mp="s21gc6a6u3xc" />
          <figcaption className="mt-2 px-5 text-center font-display text-lg font-semibold uppercase tracking-wide text-navy-900" data-id="element-196" data-mp="n98fvulr5hr2">
            The 6 Volumes + 5 Bonuses Inside Implant Risk Radar™
          </figcaption>
        </figure>

        <div className="mt-8" data-id="element-197" data-mp="1b1fel0eya0tn">
          <OfferBlock id="first-cta" label="Get Implant Risk Radar™" meta="Immediate digital access · One-time payment of USD $27 · Lifetime access · 7-Day Guarantee" data-id="element-198" data-mp="1azkwdtv2cmt9" />
        </div>
      </div>
    </header>;
}